import React from 'react';
import { Section } from './ui/Section';
export function ResultsSection() {
  return <Section data-id="element-193">
      <div className="text-center mb-10" data-id="element-194">
        <h2 className="text-3xl md:text-4xl font-serif text-cream-50 mb-4" data-id="element-195">
          Lo que podrías notar
        </h2>
        <p className="text-amber-500 uppercase tracking-widest text-sm font-medium" data-id="element-196">
          En las primeras semanas
        </p>
      </div>

      <div className="prose prose-invert prose-lg mx-auto text-cream-100 leading-relaxed" data-id="element-197">
        <p className="mb-6" data-id="element-198">No te voy a decir "vas a dormir perfecto".</p>
        <p className="mb-8" data-id="element-199">Pero muchas mujeres notan algo más real:</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" data-id="element-200">
          {['menos pánico cuando se despiertan', 'menos tiempo peleando con la mente', 'más facilidad para "volver"', 'sensación de control (que cambia todo)'].map((item, i) => <div key={i} className="bg-warm-800 p-4 rounded-lg border border-warm-700 flex items-center" data-id="element-201">
              <span className="w-2 h-2 bg-amber-500 rounded-full mr-3" data-id="element-202"></span>
              <span className="font-medium text-cream-50" data-id="element-203">{item}</span>
            </div>)}
        </div>

        <p className="text-xl font-serif italic text-center text-amber-100 bg-warm-800/30 p-6 rounded-xl border border-warm-700" data-id="element-204">
          "Cuando recuperas control, el cuerpo deja de tratar la noche como una
          emergencia."
        </p>
      </div>
    </Section>;
}